// Detect if running inside an Android Trusted Web Activity (TWA) wrapper.
// Used to comply with Google Play Billing policy by hiding Stripe upgrade
// flows when running inside the Android app (users continue payments on web).
export function isAndroidTWA() {
  if (typeof window === "undefined") return false;
  // 1. document.referrer starts with "android-app://"
  if (typeof document !== "undefined" && document.referrer && document.referrer.startsWith("android-app://")) {
    return true;
  }
  // 2. Standalone display mode + Android UA (TWA installs as PWA)
  const isStandalone = window.matchMedia && window.matchMedia("(display-mode: standalone)").matches;
  const ua = navigator.userAgent || "";
  if (isStandalone && /Android/i.test(ua)) return true;
  // 3. Explicit override (testing)
  if (typeof window !== "undefined" && window.__SPARK_TWA__) return true;
  return false;
}
